import transliterate from './transliterate';

const TRACKER_ID = 'G-JTN4FER772';

export const trackPageview = (path) => {
  if (window.gtag) {
    window.gtag('config', TRACKER_ID, {
      page_path: path,
    });
  }
};

export const trackGA = ({
  event_id,
  screenName,
  eventName,
  eventCategory,
  eventAction,
  eventLabel,
  eventContent = null,
  eventContext = null,
  productType = null,
  productName = null,
  productID = null,
  user_id,
}) => {
  if (window.gtag) {
    window.gtag('event', eventName, {
      event_id,
      screenName,
      eventCategory,
      eventAction,
      eventLabel,
      user_id,
      ...(eventContent && { eventContent }),
      ...(eventContext && { eventContext }),
      ...(productType && { productType }),
      ...(productName && { productName }),
      ...(productID && { productID }),
    });

    // if (process.env.NODE_ENV === 'development') {
    //   let logMessage = `%cGA tracked: ${event_id}|${screenName}|${eventName}|${eventCategory}|${eventAction}|${eventLabel}`;

    //   if (user_id) {
    //     logMessage += `\nUser ID: ${user_id}`;
    //   }

    //   if (eventContent) {
    //     logMessage += `\nContent: ${eventContent}`;
    //   }

    //   if (eventContext) {
    //     logMessage += `\nContext: ${eventContext}`;
    //   }

    //   if (productType) {
    //     logMessage += `\nProduct Type: ${productType}`;
    //   }

    //   if (productName) {
    //     logMessage += `\nProduct Name: ${productName}`;
    //   }

    //   if (productID) {
    //     logMessage += `\nProduct ID: ${productID}`;
    //   }

    //   console.log(logMessage, 'background: #D7F1FF; padding: 2px 4px; border-radius: 4px;');
    // }
  }
};

//

export const gaEvent = {
  // События просмотра экрана. Должно срабатывать на каждом новом экране.
  pageShow: ({ screenName }) => ({
    event_id: '1.0',
    screenName,
    eventName: 'nxPageview',
    eventCategory: 'pageview',
    eventLabel: screenName,
  }),

  // Факт ввода данных (ввод хотя бы 3 символов + 3 секунды без ввода) в поле "телефон" на странице авторизации после клика на кнопку "вход"
  loginPhoneInput: () => ({
    event_id: '10.0',
    screenName: '/login',
    eventName: 'nxLogin',
    eventCategory: 'login',
    eventAction: 'form_fill',
    eventLabel: 'nomer_telefona',
  }),

  // Клик на кнопки appstore и google play на странице логинки для перехода на загрузку приложения
  downloadAppClick: ({ eventContent }) => ({
    event_id: '11.0',
    screenName: '/login',
    eventName: 'nxLogin',
    eventCategory: 'login',
    eventAction: 'element_click',
    eventLabel: 'skachat_prilozhenie',
    eventContent,
  }),

  // Клик на кнопки на странице авторизации.
  loginButtonsClick: ({ eventLabel }) => ({
    event_id: '12.0',
    screenName: '/login',
    eventName: 'nxLogin',
    eventCategory: 'login',
    eventAction: 'button_click',
    eventLabel,
  }),

  // Показ поп-апа "Регистрация" после нажатия на кнопку "Нет аккаунта? зарегистрируйтесь" на странице авторизации, либо после нажатия на кнопку "регистрация" на главной
  registrationPopupShow: () => ({
    event_id: '13.0',
    screenName: '/login',
    eventName: 'nxLogin',
    eventCategory: 'login',
    eventAction: 'popup_show',
    eventLabel: 'registraciya',
  }),

  // Факт ввода данных (ввод хотя бы 3 символов + 3 секунды без ввода) в поля "Имя" "Фамилия" "Номер телефона" "e-mail" на попапе после нажатия на кнопку "Нет аккаунта? зарегистрируйтесь" на странице авторизации, либо после нажатия на кнопку "регистрация" на главной
  registrationFormInput: ({ eventLabel }) => ({
    event_id: '14.0',
    screenName: '/login',
    eventName: 'nxLogin',
    eventCategory: 'login',
    eventAction: 'form_fill',
    eventLabel,
    eventContext: 'registraciya',
  }),

  // Клик на выпадающее меню "Выберите ваше место работы" или "Выберите город" на попапе после нажатия на кнопку "Нет аккаунта? зарегистрируйтесь" на странице авторизации, либо после нажатия на кнопку "регистрация" на главной
  registrationDropdownClick: ({ eventLabel }) => ({
    event_id: '15.0',
    screenName: '/login',
    eventName: 'nxLogin',
    eventCategory: 'login',
    eventAction: 'element_click',
    eventLabel,
    eventContext: 'registraciya',
  }),

  // Клик на выбор города или типа работы в выпадающих меню на попапе после нажатия на кнопку "Нет аккаунта? зарегистрируйтесь" на странице авторизации, либо после нажатия на кнопку "регистрация" на главной
  registrationDropdownOptionClick: ({ eventLabel, eventContent }) => ({
    event_id: '16.0',
    screenName: '/login',
    eventName: 'nxLogin',
    eventCategory: 'login',
    eventAction: 'element_click',
    eventLabel,
    eventContent,
    eventContext: 'registraciya',
  }),

  // Клик на кнопки на попапе после нажатия на кнопку "Нет аккаунта? зарегистрируйтесь" на странице авторизации, либо после нажатия на кнопку "регистрация" на главной
  registrationButtonsClick: ({ eventLabel }) => ({
    event_id: '17.0',
    screenName: '/login',
    eventName: 'nxLogin',
    eventCategory: 'login',
    eventAction: 'element_click',
    eventLabel,
    eventContext: 'registraciya',
  }),

  // Показ "Некорректно введен email" "Некорректно введено имя" "Некорректно введена фамилия" на попапе после нажатия на кнопку "Нет аккаунта? зарегистрируйтесь" на странице авторизации, либо после нажатия на кнопку "регистрация" на главной
  registrationErrorsShow: ({ eventLabel }) => ({
    event_id: '18.0',
    screenName: '/login',
    eventName: 'nxLogin',
    eventCategory: 'login',
    eventAction: 'element_show',
    eventLabel,
    eventContext: 'registraciya',
  }),

  // Факт успешной регистрации после заполнения формы на попапе после нажатия на кнопку "Нет аккаунта? зарегистрируйтесь" на странице авторизации, либо после нажатия на кнопку "регистрация" на главной
  registrationSuccess: () => ({
    event_id: '19.0',
    screenName: '/login',
    eventName: 'nxLogin',
    eventCategory: 'login',
    eventAction: 'confirmed',
    eventLabel: 'uspeshnaya_registraciya',
    eventContext: 'registraciya',
  }),

  // Клик на кнопки главного меню внутри приложения
  headerButtonsClick: ({ eventLabel, user_id }) => ({
    event_id: '52.0',
    screenName: '/',
    eventName: 'nxAppMainMenu',
    eventCategory: 'app_main_menu',
    eventAction: 'element_click',
    eventLabel,
    user_id,
  }),

  // Клик на выбор типа поиска или кнопки закрыть на попапе "поиск" внутри приложения
  searchButtonsClick: ({ eventLabel, user_id }) => ({
    event_id: '53.0',
    screenName: '/',
    eventName: 'nxAppSearch',
    eventCategory: 'app_search',
    eventAction: 'element_click',
    eventLabel,
    user_id,
  }),

  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода)  в поле "Поиск"
  searchInput: ({ eventLabel, eventContent, eventContext, user_id }) => ({
    event_id: '54.0',
    screenName: '/',
    eventName: 'nxAppSearch',
    eventCategory: 'app_search',
    eventAction: 'form_fill',
    eventLabel,
    eventContent,
    eventContext: transliterate(eventContext),
    user_id,
  }),

  // Клик по кнопкам в выпадающем меню при нажатии на кнопку "Профиль" в главном меню
  profileDropdownButtonsClick: ({ eventLabel, user_id }) => ({
    event_id: '55.0',
    screenName: '/',
    eventName: 'nxAppProfile',
    eventCategory: 'app_profile',
    eventAction: 'element_click',
    eventLabel,
    user_id,
  }),

  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в полях на странице профиля
  profileFormInput: ({ eventLabel, user_id }) => ({
    event_id: '56.0',
    screenName: '/profile',
    eventName: 'nxAppProfile',
    eventCategory: 'app_profile',
    eventAction: 'form_fill',
    eventLabel,
    user_id,
  }),

  // Клик на кнопки на странице профиля
  profileButtonsClick: ({ eventLabel, user_id }) => ({
    event_id: '57.0',
    screenName: '/profile',
    eventName: 'nxAppProfile',
    eventCategory: 'app_profile',
    eventAction: 'button_click',
    eventLabel,
    user_id,
  }),

  // Показ ошибок при заполнении полей на странице профиля
  profileSaveSuccessAndErrorsShow: ({ eventContent, eventLabel, user_id }) => ({
    event_id: '58.0',
    screenName: '/profile',
    eventName: 'nxAppProfile',
    eventCategory: 'app_profile',
    eventAction: 'element_show',
    eventLabel,
    eventContent,
    user_id,
  }),

  // Клик на пункты фильтра объектов на главной странице
  filterButtonsClick: ({ eventLabel, eventContext, productType, user_id }) => ({
    event_id: '59.0',
    screenName: '/',
    eventName: 'nxAppFilter',
    eventCategory: 'app_filter',
    eventAction: 'element_click',
    eventLabel,
    eventContext,
    productType,
    user_id,
  }),

  // Выбор района на вкладке фильтра "район"
  filterDistrictButtonsClick: ({ eventContent, eventContext, productType, user_id }) => ({
    event_id: '60.0',
    screenName: '/',
    eventName: 'nxAppFilter',
    eventCategory: 'app_filter',
    eventAction: 'element_click',
    eventLabel: 'raion',
    eventContent: transliterate(eventContent[0]) + eventContent[1],
    eventContext,
    productType,
    user_id,
  }),

  // Выбор микрорайона на вкладке фильтра "район"
  filterMicrodistrictButtonsClick: ({ eventContent, eventContext, productType, user_id }) => ({
    event_id: '61.0',
    screenName: '/',
    eventName: 'nxAppFilter',
    eventCategory: 'app_filter',
    eventAction: 'element_click',
    eventLabel: 'mikroraion',
    eventContent: transliterate(eventContent[0]) + eventContent[1],
    eventContext,
    productType,
    user_id,
  }),

  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в полях "цена от" "цена до" или "площадь от" "площадь до" на вкладках фильтра "цена" или "площадь"
  filterInput: ({ eventLabel, eventContent, eventContext, productType, user_id }) => ({
    event_id: '62.0',
    screenName: '/',
    eventName: 'nxAppFilter',
    eventCategory: 'app_filter',
    eventAction: 'form_fill',
    eventLabel,
    eventContent,
    eventContext,
    productType,
    user_id,
  }),

  // Выбор остальных параметров (отделка, оформление, срок сдачи, варианты оплаты, тип недвижимости, расстояние до моря, класс дома, преимущества, вид из окна) на соответствующих вкладках фильтра
  // TODO: patameter_filtra - parameter ??
  filterCheckboxesClick: ({ eventContent, eventContext, productType, user_id }) => ({
    event_id: '63.0',
    screenName: '/',
    eventName: 'nxAppFilter',
    eventCategory: 'app_filter',
    eventAction: 'element_click',
    eventLabel: 'parameter_filtra',
    eventContent: transliterate(eventContent[0]) + eventContent[1],
    eventContext,
    productType,
    user_id,
  }),

  // Клик по быстрому фильтру (nedvex, новинки, акции, популярное ) на главной странице приложения
  filterTypeButtonsClick: ({ eventLabel, eventContent, eventContext, productType, user_id }) => ({
    event_id: '64.0',
    screenName: '/',
    eventName: 'nxAppFilter',
    eventCategory: 'app_filter',
    eventAction: 'element_click',
    eventLabel,
    eventContent,
    eventContext,
    productType,
    user_id,
  }),

  // Клик по кнопке "сбросить фильтр" на лююбой вкладке общего фильтра или быстрого фильтра "nedvex"
  filterClearButtonsClick: ({ eventContent, eventContext, productType, user_id }) => ({
    event_id: '65.0',
    screenName: '/',
    eventName: 'nxAppFilter',
    eventCategory: 'app_filter',
    eventAction: 'element_click',
    eventLabel: 'sbrosit_filtr',
    eventContent,
    eventContext,
    productType,
    user_id,
  }),

  // Клик на выбор сортировки на фильтре на главной странице
  filterSortByButtonsClick: ({ eventContent, eventContext, productType, user_id }) => ({
    event_id: '66.0',
    screenName: '/',
    eventName: 'nxAppFilter',
    eventCategory: 'app_filter',
    eventAction: 'element_click',
    eventLabel: 'sortirovka',
    eventContent,
    eventContext,
    productType,
    user_id,
  }),

  // Клик по кнопке выбора отображения объектов недвижимости "карта" "искать на списке"
  filterListModeSwitchClick: ({ eventLabel, eventContext, productType, user_id }) => ({
    event_id: '67.0',
    screenName: '/',
    eventName: 'nxAppFilter',
    eventCategory: 'app_filter',
    eventAction: 'element_click',
    eventLabel,
    eventContext,
    productType,
    user_id,
  }),

  // Показ карточки объекта недвижимости в любом месте на сайте
  buildingCardShow: ({
    screenName,
    eventContent,
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '68.0',
    screenName,
    eventName: 'nxAppObjectCard',
    eventCategory: 'app_object_card',
    eventAction: 'card_show',
    eventLabel: 'kartochka_obyekta',
    eventContent,
    eventContext,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на элементы на карточке объекта, либо на саму карточку (для перехода на страницу объекта)
  buildingCardClick: ({
    screenName,
    eventLabel,
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '69.0',
    screenName,
    eventName: 'nxAppObjectCard',
    eventCategory: 'app_object_card',
    eventAction: 'element_click',
    eventLabel,
    eventContext,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на кнопки "все" "избранное" "от сервиса" в разделе "новости" на главной странице
  // TODO: name и id объекта тут быть не может
  newsButtonsClick: ({ eventLabel, eventContext, productType, user_id }) => ({
    event_id: '70.0',
    screenName: '/',
    eventName: 'nxAppNews',
    eventCategory: 'app_news',
    eventAction: 'element_click',
    eventLabel,
    eventContext,
    productType,
    user_id,
  }),

  // Показ карточки с новостью на страницах сайта
  newsCardShow: ({
    screenName,
    eventContent,
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '71.0',
    screenName,
    eventName: 'nxAppNewsCard',
    eventCategory: 'app_news_card',
    eventAction: 'card_show',
    eventLabel: 'kartochka_novosti',
    eventContent: transliterate(eventContent),
    eventContext,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик по карточке новости или на элемент "Читать далее" на карточке новости на страницах сайта
  newsCardClick: ({
    screenName,
    eventContent,
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '72.0',
    screenName,
    eventName: 'nxAppNewsCard',
    eventCategory: 'app_news_card',
    eventAction: 'element_click',
    eventLabel: 'chitat_dalee',
    eventContent: transliterate(eventContent),
    eventContext,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик по наименованию объекта на карточке новости
  newsCardObjectLinkClick: ({
    screenName,
    eventContent,
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '73.0',
    screenName,
    eventName: 'nxAppNewsCard',
    eventCategory: 'app_news_card',
    eventAction: 'element_click',
    eventLabel: 'obyekt',
    eventContent: transliterate(eventContent),
    eventContext,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Показ верхнего баннера объекта на странице объекта, срабатывает повторно при свайпе картинки
  buildingImageShow: ({
    eventContent,
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '74.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'banner_show',
    eventLabel: 'banner_obyekta',
    eventContent: transliterate(eventContent),
    eventContext,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик по кнопкам в верхней части страницы объекта: "сообщить о неточности" "в подборку" "в избранное" "поделиться" "печать информации"  "шахматка" "информация о ЖК/КП"
  buildingTitleButtonsClick: ({
    eventLabel,
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '75.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel,
    eventContent: transliterate(eventContent),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в поле на попапе  "Сообщить о неточности" после нажатия на кнопку "Сообщить о неточности"  на странице объекта
  buildingInaccuracyReportInput: ({
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '76.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'form_fill',
    eventLabel: 'soobshchit_o_netochnosti',
    eventContent: transliterate(eventContent),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на кнопки на попапе  "Сообщить о неточности" после нажатия на кнопку "Сообщить о неточности"  на странице объекта
  buildingInaccuracyReportButtonsClick: ({
    eventLabel,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '77.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel,
    eventContent: 'soobshchit_o_netochnosti',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на выбор подборки на попапе "добавить в подборку" после нажатия на кнопку "добавить в подборку" на странице объекта
  buildingPickCollectionButtonClick: ({
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '78.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'nazvanie_podborki',
    eventContent: transliterate(eventContent[0]) + eventContent[1],
    eventContext: 'dobavit_v_podborku',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на кнопки на попапе "добавить в подборку" после нажатия на кнопку "добавить в подборку" на странице объекта
  buildingCollectionDialogButtonsClick: ({
    eventLabel,
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '79.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel,
    eventContent: transliterate(eventContent),
    eventContext: 'dobavit_v_podborku',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в поле "Введите название новой подборки" на попапе "добавить в подборку" после нажатия на кнопку "добавить в подборку" на странице объекта
  buildingCollectionDialogInput: ({
    eventLabel,
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '80.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'form_fill',
    eventLabel: 'novaya_podborka',
    eventContent: transliterate(eventContent),
    eventContext: 'dobavit_v_podborku',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Показ всплывающего окна "ЖК добавлен в избранное" и "ЖК убран из избранного" после нажатия на кнопку "Добавить в избранное" на странице объекта
  buildingFavoritesResult: ({
    eventLabel,
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '81.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_show',
    eventLabel,
    eventContent: transliterate(eventContent),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на пункты выбора раздела на попапе после нажатия на кнопку "поделиться" на странице объекта
  buildingShareCheckboxesPick: ({
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '82.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'parametr_podelitsya',
    eventContent: transliterate(eventContent[0]) + eventContent[1],
    eventContext: 'podelitsya',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на кнопки на попапе "поделиться" после нажатия на кнопку "поделиться" на странице объекта
  buildingShareButtonsClick: ({
    eventLabel,
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '83.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel,
    eventContent: transliterate(eventContent),
    eventContext: 'podelitsya',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Выбор пункта на попапе "Печать" после нажатия на кнопку "Печать" на странице объекта
  buildingPrintCheckboxesPick: ({
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '84.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'punkt_pechati',
    eventContent: transliterate(eventContent),
    eventContext: 'pechat_informacii',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на элементы на попапе "Печать" после нажатия на кнопку "Печать" на странице объекта
  buildingPrintButtonsClick: ({
    eventLabel,
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '85.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel,
    eventContent: transliterate(eventContent),
    eventContext: 'pechat_informacii',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на кнопки "посмотреть все фото" "на карте" на баннере на странице объекта
  buildingGalleryButtonsClick: ({
    eventLabel,
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '86.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel,
    eventContent: transliterate(eventContent),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на выбор подборки фото или на кнопку закрыть на попапе  "все фото" после нажатия на кнопку "посмотреть все фото" на странице объекта
  buildingGalleryAlbumsButtonsClick: ({
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '87.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'foto_podborka',
    eventContent: transliterate(eventContent),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Показ фото на попапе  "все фото" после нажатия на кнопку "посмотреть все фото" на странице объекта
  buildingGalleryModalImageShow: ({
    eventContent,
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '88.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_show',
    eventLabel: 'foto_obyekta',
    eventContent,
    eventContext: transliterate(eventContext),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на кнопки "читать далее" или "смотреть все новости" на странице объекта
  buildingNewsLinksClick: ({ productType, productName, productID, user_id }) => ({
    event_id: '89.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'smotret_vse_novosti',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на кнопку закрыть на попапе "все новости" после клика на кнопки "читать далее" или "смотреть все новости" на странице объекта
  buildingNewsDialogClose: ({ productType, productName, productID, user_id }) => ({
    event_id: '90.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'zakryt',
    eventContent: 'vse_novosti',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Показ информационных блоков на странице объекта
  buildingInfoBlocksShow: ({ eventLabel, productType, productName, productID, user_id }) => ({
    event_id: '91.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_show',
    eventLabel,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на элементы "свернуть" "подробнее" в разделах  на странице объекта
  buildingInfoBlocksExpand: ({
    eventLabel,
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '92.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel,
    eventContent,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на элемент "Смотреть шахматку" в разделе "корпуса" на странице объекта
  buildingChessLinkClick: ({ eventContent, productType, productName, productID, user_id }) => ({
    event_id: '93.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'smotret_shahmatku',
    eventContent: transliterate(eventContent),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на кнопки перелистывания похожих проектов в разделе ДРУГИЕ ЖК В МИКРОРАЙОНЕ на странице объекта
  buildingSuggestionsButtonsClick: ({
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '94.0',
    screenName: '/building/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'drugie_zhk_strelka',
    eventContent,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на переключение между режимами "шахматка" и "список" на странице квартир объекта
  buildingChessSwitcherClick: ({ eventLabel, productType, productName, productID, user_id }) => ({
    event_id: '95.0',
    screenName: '/building/chess/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на раскрытие падающего меню со списком корпусов объекта на странице "шахматка"
  buildingChessDropdownClick: ({ productType, productName, productID, user_id }) => ({
    event_id: '96.0',
    screenName: '/building/chess/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'vybor_korpusa',
    eventContent: 'shahmatka',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Выбор корпуса в меню выбора корпусов объекта на странице "шахматка"
  buildingChessDropdownListItemClick: ({
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '97.0',
    screenName: '/building/chess/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'korpus',
    eventContent: transliterate(eventContent),
    eventContext: 'shahmatka',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на кнопки фильтрации на странице шахматка (в режимах "шахматка" и "список")
  buildingChessFiltersClick: ({
    eventContent,
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '98.0',
    screenName: '/building/chess/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'filtr',
    eventContent,
    eventContext,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в полях "цена от" "цена до" или "площадь" на вкладках фильтра "цена" или "площадь" на странице шахматка или на попапе "планировка этажа" после нажатия на кнопку "увеличить планировку этажа" в правой части страницы
  buildingChessFiltersInput: ({
    eventLabel,
    eventContent,
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '99.0',
    screenName: '/building/chess/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'form_fill',
    eventLabel,
    eventContent,
    eventContext,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Выбор параметров в остальных разделах фильтра на странице шахматка или на попапе "планировка этажа" после нажатия на кнопку "увеличить планировку этажа" в правой части страницы
  buildingChessFilterCheckboxesClick: ({
    eventContent,
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '100.0',
    screenName: '/building/chess/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'parameter_filtra',
    eventContent: transliterate(eventContent[0]) + eventContent[1],
    eventContext,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Показ ховера с информацией о квартире при наведении на ячейку шахматки на странице шахматка объекта или на попапе "планировка этажа" после нажатия на кнопку "увеличить планировку этажа" в правой части страницы
  buildingChessLotHover: ({ eventContent, productType, productName, productID, user_id }) => ({
    event_id: '101.0',
    screenName: '/building/chess/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_hover',
    eventLabel: 'hover_kvartira',
    eventContent,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на карточку квартиры на шахматке или на списке квартир на странице "шахматка объекта"
  buildingChessLotClick: ({
    eventContent,
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '102.0',
    screenName: '/building/chess/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'kartochka_kvartiry',
    eventContent,
    eventContext,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на элементы в правой части страницы шахматка при отображении выбранной квартиры в режимах "шахматка" и "список" а также на попапе  "планировка этажа" после нажатия на кнопку "увеличить планировку этажа"  в правой части страницы шахматка в режимах "шахматка" и "список"
  buildingChessLotAboutButtonsClick: ({
    eventLabel,
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '103.0',
    screenName: '/building/chess/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel,
    eventContext,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на кнопку закрыть на попапе "планировка квартиры" после нажатия на кнопку увеличить планировку  в правой части страницы шахматка в режимах "шахматка" и "список"
  buildingChessLotPlanCloseClick: ({
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '104.0',
    screenName: '/building/chess/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'zakryt',
    eventContent: 'planirovka_kvartiry',
    eventContext,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на кнопки на попапе "планировка этажа" после нажатия на кнопку "увеличить планировку этажа"  в правой части страницы шахматка в режимах "шахматка" и "список"
  buildingChessFloorDialogButtonsClick: ({
    eventLabel,
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '105.0',
    screenName: '/building/chess/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel,
    eventContent: 'planirovka_etazha',
    eventContext,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Выбор сортировки при отображении квартир на странице шахматка объекта в режиме "список"
  buildingChessListSortButtonsClick: ({
    eventContent,
    eventContext,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '106.0',
    screenName: '/building/chess/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'sortirovka_spiska',
    eventContent,
    eventContext,
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Показ уведомления "все лоты проданы" на страницы шахматка
  buildingChessListSoldOutCardShow: ({
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '107.0',
    screenName: '/building/chess/',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_show',
    eventLabel: 'vse_loty_prodany',
    eventContent: transliterate(eventContent),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Показ карточки подборки на странице "Подборки"
  collectionsListItemShow: ({ eventContent, user_id }) => ({
    event_id: '108.0',
    screenName: '/collections/',
    eventName: 'nxAppCollectionCard',
    eventCategory: 'app_collection_card',
    eventAction: 'element_show',
    eventLabel: 'kartochka_podborki',
    eventContent: transliterate(eventContent),
    user_id,
  }),

  // Клик на кнопки на карточке подборки или на саму карточку на странице подборки или других страницах
  collectionsListItemButtonsClick: ({ eventLabel, user_id }) => ({
    event_id: '109.0',
    screenName: '/collections/',
    eventName: 'nxAppCollectionCard',
    eventCategory: 'app_collection_card',
    eventAction: 'element_click',
    eventLabel,
    user_id,
  }),

  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в поле имени  подборки при нажатии на кнопку "переименовать"
  collectionsListItemRenameInput: ({ eventContent, user_id }) => ({
    event_id: '110.0',
    screenName: '/collections/',
    eventName: 'nxAppCollectionCard',
    eventCategory: 'app_collection_card',
    eventAction: 'form_fill',
    eventLabel: 'pereimenovat',
    eventContent: transliterate(eventContent),
    user_id,
  }),

  // Клик на кнопку "Создать подборку" на странице "подборки"
  collectionsCreateButtonClick: ({ user_id }) => ({
    event_id: '111.0',
    screenName: '/collections/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'element_click',
    eventLabel: 'sozdat_podborku',
    user_id,
  }),

  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в поле имени подборки при нажатии на кнопку "Создать подборку" на странице "подборки"
  collectionsCreateDialogInput: ({ user_id }) => ({
    event_id: '112.0',
    screenName: '/collections/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'form_fill',
    eventLabel: 'nazvanie_podborki',
    user_id,
  }),

  // Клик на кнопки на попапе "Создать подборку" при нажатии на кнопку "Создать подборку" на странице подборки
  collectionsCreateDialogButtonsClick: ({ eventLabel, user_id }) => ({
    event_id: '113.0',
    screenName: '/collections/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'element_click',
    eventLabel,
    eventContent: 'nazvanie_podborki',
    user_id,
  }),

  // Клик на кнопки на попапе  "Удаление подборки" при нажатии на кнопку "Удалить" на карточке подборки на странице "Подборки"
  collectionsDeleteDialogButtonsClick: ({ eventLabel, user_id }) => ({
    event_id: '114.0',
    screenName: '/collections/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'element_click',
    eventLabel,
    eventContent: 'udalit_podborku',
    user_id,
  }),

  // Показ всплывающего окна "Подборка удалена"  после нажатия на кнопку "Удалить" на попапе "Удаление подборки" на странице Подборки
  collectionsDeleteResult: ({ user_id }) => ({
    event_id: '115.0',
    screenName: '/collections/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'element_show',
    eventLabel: 'podborka_udalena',
    user_id,
  }),

  // Клик на кнопку "Поделиться" на странице конкрентой подборки
  collectionShareButtonClick: ({ eventContext, user_id }) => ({
    event_id: '116.0',
    screenName: '/collections/manage/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'element_click',
    eventLabel: 'podelitsya_podborkoi',
    eventContext: transliterate(eventContext),
    user_id,
  }),

  // Клик на кнопки на карточке объекта на странице конкретной подборки
  collectionListItemButtonsClick: ({
    eventLabel,
    eventContext,
    productType,
    productID,
    productName,
    user_id,
  }) => ({
    event_id: '117.0',
    screenName: '/collections/manage/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'element_click',
    eventLabel,
    eventContext: transliterate(eventContext),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в поле комментарий после нажатия на кнопку "Добавить комментарий" на странице подборки
  collectionListItemCommentInput: ({
    eventContext,
    productType,
    productID,
    productName,
    user_id,
  }) => ({
    event_id: '118.0',
    screenName: '/collections/manage/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'form_fill',
    eventLabel: 'dobavit_kommentarii',
    eventContext: transliterate(eventContext),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Факт ввода данных (ввод хотя бы 2 символов + 3 секунды без ввода) в поле комментарий после нажатия на кнопку "Добавить комментарий" на странице подборки
  collectionListItemCommentButtonsClick: ({
    eventLabel,
    eventContext,
    productType,
    productID,
    productName,
    user_id,
  }) => ({
    event_id: '119.0',
    screenName: '/collections/manage/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'element_click',
    eventLabel,
    eventContext: transliterate(eventContext),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Показ всплывающих окон "ЖК удален из подборки" и "ЖК добавлен в подборку" на странице подборки
  collectionAddAndDeleteBuildingResult: ({
    eventLabel,
    eventContext,
    productType,
    productID,
    productName,
    user_id,
  }) => ({
    event_id: '120.0',
    screenName: '/collections/manage/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'element_show',
    eventLabel,
    eventContext: transliterate(eventContext),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на кнопки отменить и закрыть на всплывающем окне "ЖК удален из подборки" на странице подборки
  collectionNotificationButtonsClick: ({
    eventLabel,
    eventContext,
    productType,
    productID,
    productName,
    user_id,
  }) => ({
    event_id: '121.0',
    screenName: '/collections/manage/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'element_click',
    eventLabel,
    eventContext: transliterate(eventContext),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Показ баннера "Пустая подборка" на странице подборки
  collectionEmptyCardShow: ({ eventContext, user_id }) => ({
    event_id: '122.0',
    screenName: '/collections/manage/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'element_show',
    eventLabel: 'pustaya_podborka',
    eventContext: transliterate(eventContext),
    user_id,
  }),

  // Клик на кнопку "Перейти к списку объектов" на баннере "Пустая подборка" на странице подборки
  collectionEmptyCardButtonClick: ({ eventContext, user_id }) => ({
    event_id: '123.0',
    screenName: '/collections/manage/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'element_click',
    eventLabel: 'pereiti_k_spisku',
    eventContent: 'pustaya_podborka',
    eventContext: transliterate(eventContext),
    user_id,
  }),

  // Раскрытие падающего меню на попапе "поделиться подборкой" на странице подборки
  collectionShareDialogDropdownClick: ({ eventContext, user_id }) => ({
    event_id: '124.0',
    screenName: '/collections/manage/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'element_click',
    eventLabel: 'loty',
    eventContent: 'podelitsya_podborkoi',
    eventContext: transliterate(eventContext),
    user_id,
  }),

  // Выбор разделов на попапе "Поделиться подборкой" на странице подборки
  collectionShareDialogCheckboxesPick: ({ eventContent, eventContext, user_id }) => ({
    event_id: '125.0',
    screenName: '/collections/manage/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'element_click',
    eventLabel: 'parametr_podelitsya',
    eventContent: transliterate(eventContent[0]) + eventContent[1],
    eventContext: transliterate(eventContext),
    user_id,
  }),

  // Клик на кнопки "Скопировать" "Закрыть" на попапе "Поделиться подборкой" на странице подборки
  collectionShareDialogButtonsClick: ({ eventLabel, eventContext, user_id }) => ({
    event_id: '126.0',
    screenName: '/collections/manage/',
    eventName: 'nxAppCollection',
    eventCategory: 'app_collections',
    eventAction: 'element_click',
    eventLabel,
    eventContent: 'podelitsya_podborkoi',
    eventContext: transliterate(eventContext),
    user_id,
  }),

  // Клик на элементы на карточке объекта на странице "Избранное" на странице избранное
  favoritesBuildingCardButtonsClick: ({ eventLabel, eventContent, user_id }) => ({
    event_id: '127.0',
    screenName: '/favorites/',
    eventName: 'nxAppFavourite',
    eventCategory: 'app_favourite',
    eventAction: 'element_click',
    eventLabel,
    eventContent: transliterate(eventContent),
    user_id,
  }),

  // Показ вспылвающих окон "ЖК удален из избранного"  или "ЖК добавлен в избранного" на странице избранное
  favoritesAddAndDeleteBuildingResult: ({ eventLabel, eventContent, user_id }) => ({
    event_id: '128.0',
    screenName: '/favorites/',
    eventName: 'nxAppFavourite',
    eventCategory: 'app_favourite',
    eventAction: 'element_show',
    eventLabel,
    eventContent: transliterate(eventContent),
    user_id,
  }),

  // Клик на кнопки "Отменить" "Закрыть" на всплывающих окнах "ЖК удален из избранного" и "ЖК добавлен в избранное" на странице избранное
  favoritesNotificationButtonsClick: ({ eventLabel, eventContent, user_id }) => ({
    event_id: '129.0',
    screenName: '/favorites/',
    eventName: 'nxAppFavourite',
    eventCategory: 'app_favourite',
    eventAction: 'element_click',
    eventLabel,
    eventContent: transliterate(eventContent),
    user_id,
  }),

  // Клик на кнопку "Связаться с нами" на любой странице сайта
  supportClick: ({ screenName, user_id }) => ({
    event_id: '130.0',
    screenName,
    eventName: 'nxAppContact',
    eventCategory: 'app_contact',
    eventAction: 'element_click',
    eventLabel: 'svyazatsya_s_nami',
    user_id,
  }),

  // Клик на выбор способа связи в меню "Связаться с нами" на любой странице сайта
  supportDialogButtonsClick: ({ screenName, eventLabel, user_id }) => ({
    event_id: '131.0',
    screenName,
    eventName: 'nxAppContact',
    eventCategory: 'app_contact',
    eventAction: 'element_click',
    eventLabel,
    user_id,
  }),

  // Клик на локацию в попапе выбор страны
  locationDialogButtonsClick: ({ eventContent, user_id }) => ({
    event_id: '132.0',
    screenName: '/',
    eventName: 'nxAppLocation',
    eventCategory: 'app_location',
    eventAction: 'element_click',
    eventLabel: 'lokaciya',
    eventContent: `${transliterate(eventContent[0])} | ${transliterate(eventContent[1])}`,
    user_id,
  }),

  // Клик на кнопку "выйти" и "отмена" после клика на "выход из агенства" на странице профиля
  leaveAgencyDialogButtonsClick: ({ eventLabel, user_id }) => ({
    event_id: '133.0',
    screenName: '/profile',
    eventName: 'nxAppProfile',
    eventCategory: 'app_profile',
    eventAction: 'button_click',
    eventLabel,
    eventContent: 'vyiti_iz_agentstva',
    user_id,
  }),

  // Клик на кнопки "Выйти из аккаунта" и "Выйти из агенства" на экране "Доступ приостановлен"
  agencyNoAccessButtonsClick: ({ eventLabel, user_id }) => ({
    event_id: '134.0',
    screenName: '/',
    eventName: 'nxAppProfile',
    eventCategory: 'app_profile',
    eventAction: 'button_click',
    eventLabel,
    eventContext: 'dostup_priostanovlen',
    user_id,
  }),

  // Клик на кнопки "Выйти" и "Отмена" на попапе после нажатия "Выйти из агентсва" на экране "Доступ приостановлен"
  agencyNoAccessDialogButtonsClick: ({ screenName, eventLabel, user_id }) => ({
    event_id: '136.0',
    screenName,
    eventName: 'nxAppProfile',
    eventCategory: 'app_profile',
    eventAction: 'button_click',
    eventLabel,
    eventContent: 'vyiti_iz_agentstva',
    eventContext: 'dostup_priostanovlen',
    user_id,
  }),

  // Показ информационного баннера на любой странице
  infoBannerShow: ({ screenName, eventContent, user_id }) => ({
    event_id: '137.0',
    screenName,
    eventName: 'nxAppBanner',
    eventCategory: 'app_banner',
    eventAction: 'banner_show',
    eventLabel: 'banner_info',
    eventContent: transliterate(eventContent),
    user_id,
  }),

  // Клик по информационному баннеру на любой странице
  infoBannerClick: ({ screenName, eventContent, user_id }) => ({
    event_id: '138.0',
    screenName,
    eventName: 'nxAppBanner',
    eventCategory: 'app_banner',
    eventAction: 'banner_click',
    eventLabel: 'banner_info',
    eventContent: transliterate(eventContent),
    user_id,
  }),

  // Клик на документ на странице объекта
  documentClick: ({ screenName, productType, productName, productID, user_id }) => ({
    event_id: '139.0',
    screenName,
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel: 'skachivanie_dokumenta',
    eventContent: transliterate(productName),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик на странице объекта на кнопку:
  // - показать контакты
  // - записаться на показ
  // - сообщить о неточности
  buildingRightMenuButtonsClick: ({
    eventLabel,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '140.0',
    screenName: '/building',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'button_click',
    eventLabel,
    eventContent: transliterate(productName),
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // В процессе записи на показ в модальном окне клик на:
  // - вкладку "ОФФЛАЙН" или "ОНЛАЙН", где осуществляется выбор свободного тайм-слота
  // - кнопку "Далее"
  // - кнопку "Записаться"
  // - кнопку "В мои записи", где осуществляется информирование, что запись успшно осуществлена
  // - кнопку "Хорошо", где осуществляется информирование, что запись успешно осуществлена
  appointmentDialogButtonsClick: ({
    eventLabel,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '141.0',
    screenName: '/building',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'button_click',
    eventLabel,
    eventContent: transliterate(productName),
    eventContext: 'zapis_na_pokaz',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Показа модального окна информирующего об успешной записи на показ
  appointmentDialogConfirmedResultShow: ({ productType, productName, productID, user_id }) => ({
    event_id: '142.0',
    screenName: '/building',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'confirmed',
    eventLabel: 'uspeshnaya_zapis_na_pokaz',
    eventContent: transliterate(productName),
    eventContext: 'zapis_na_pokaz',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Показа модального окна информирующего о неуспешной записи на показ
  appointmentDialogRejectedResultShow: ({ productType, productName, productID, user_id }) => ({
    event_id: '143.0',
    screenName: '/building',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'confirmed',
    eventLabel: 'neuspeshnaya_zapis_na_pokaz',
    eventContent: transliterate(productName),
    eventContext: 'neuspeshnaya_zapis_na_pokaz',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик в модальном окне записи на показ, где осуществляется информирование, что запись осуществить не удалось на кнопку:
  // - Перезаписаться
  // - Закрыть
  appointmentDialogRejectedResultButtonClick: ({
    eventLabel,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '144.0',
    screenName: '/building',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'button_click',
    eventLabel,
    eventContent: transliterate(productName),
    eventContext: 'neuspeshnaya_zapis_na_pokaz',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик в профиле на вкладку:
  // - Мои записи
  // - Мои данные
  profileTabsClick: ({ eventLabel, user_id }) => ({
    event_id: '145.0',
    screenName: '/profile',
    eventName: 'nxAppProfile',
    eventCategory: 'app_profile',
    eventAction: 'element_click',
    eventLabel,
    user_id,
  }),

  // Клик на экране "Мои записи" на вклакду:
  // - Будущие
  // - Прошедшие
  profileAppointmentsTabsClick: ({ eventLabel, user_id }) => ({
    event_id: '146.0',
    screenName: '/profile',
    eventName: 'nxAppProfile',
    eventCategory: 'app_profile',
    eventAction: 'element_click',
    eventLabel,
    eventContext: 'moi_zapisi',
    user_id,
  }),

  // Клик на экране "Мои записи" на:
  // - кнопку "Смотреть"
  profileAppointmentButtonClick: ({
    eventContent,
    productType,
    productName,
    productID,
    user_id,
  }) => ({
    event_id: '147.0',
    screenName: '/profile',
    eventName: 'nxAppProfile',
    eventCategory: 'app_profile',
    eventAction: 'element_click',
    eventLabel: 'smotret',
    eventContent,
    eventContext: 'moi_zapisi',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Показ карточки записи на показ
  profileAppointmentCardShow: ({ eventContent, productType, productName, productID, user_id }) => ({
    event_id: '148.0',
    screenName: '/profile',
    eventName: 'nxAppProfile',
    eventCategory: 'app_profile',
    eventAction: 'element_show',
    eventLabel: 'kartochka_zapisi_na_pokaz',
    eventContent,
    eventContext: 'moi_zapisi',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),

  // Клик в модальном окне контактов на:
  // - номер телефона
  // - иконку telegram
  // - иконку whatsApp
  contactsDialogButtonsClick: ({ eventLabel, productType, productName, productID, user_id }) => ({
    event_id: '149.1',
    screenName: '/building',
    eventName: 'nxAppObjectPage',
    eventCategory: 'app_object_page',
    eventAction: 'element_click',
    eventLabel,
    eventContent: transliterate(productName),
    eventContext: 'kontakty',
    productType,
    productName: transliterate(productName),
    productID,
    user_id,
  }),
};



// WEBPACK FOOTER //
// ./src/services/ga.js